export default {
  Common: {
    inputRange: '输入范围',
    maxLength: '长度最大值',
    maxByteNum: '最大字节数为',
    minLength: '长度最小值',
    minByteNum: '最小字节数为',
    maxValue: '数字最大值',
    minValue: '数字最小值',
    ok: '确定',
    cancel: '取消',
    close: '关闭',
    confirm: '确认',
    previous: '上一步',
    next: '下一步',
    refresh: '刷新',
    adSearch: '高级搜索',
    export: '导出',
    upload: '上传',
    all: '全部',
    save: '保存',
    detail: '详情',
    information: '信息',
    warning: '警告',
    success: '提示',
    error: '错误',
    day: '天',
    minute: '分钟',
    neOffLine: '网元 {0} 不在线',
    tips: {
      noSelect: '未选中任何数据',
      onlyOneSelect: '只能选择一条记录',
      selectOne: '请选择一条记录',
      success: '操作成功',
      failure: '操作失败',
      confirmTip: '确认删除所选记录？'
    }
  },
  Login: {
    title: '融合网络管理系统',
    username: '用户名称',
    password: '密码',
    kaptcha: '验证码',
    login: '登录',
    failure: '失败',
    license: 'License',
    uploadLicense: '上传license',
    forceLoginTitle: '登录提示',
    updPasswdTitle: '修改密码',
    firstLogin: '首次登录,请修改密码',
    pwdExpired: '密码已过期',
    copyright: '软件使用许可协议',
    kaptchaError: '验证码加载错误',
    footer: {
      standby: '技术支持：海能达通信股份有限公司',
      copyright: '推荐使用谷歌浏览器71以上版本，分辨率1920*1080'
    },
    copyrightInfo: {
      line1: '用户须知：请先仔细阅读本软件使用许可协议(以下简称“协议”)再使用本软件或本软件未来的更新，一经使用本软件或任何更新即表示您同意并接受本许可证的条款约束。如果您不同意本许可证的条款，请勿安装或使用本软件产品。',
      line2: '1.1 定义',
      line3: '本协议中“软件”是指所有海能达通信股份有限公司（以下简称“海能达公司”）提供给使用方的源代码、可执行代码、程序、接口、文档、数据库、数据、图片、声音、标志和标识等，包括但不限于(i)计算机源代码、可执行代码、接口程序；(ii)有关文档和文件；(iii) 提供的升级版本、软件的补丁；(iV)使用的数据库和数据。',
      line4: '1.2 知识产权',
      line5: '海能达公司拥有本软件的产权、版权和其它知识产权。本软件受版权和其它知识产权法律及条约的保护。“Hytera”、“HYT”和“海能达”为海能达公司在中华人民共和国和世界其他国家和/或地区的商标或注册商标。海能达公司仅对自有商标、产品名称、独自开发代码等知识产权享有所有权。海能达公司保留未在此协议中明示授予您的一切权利。',
      line6: '本软件可能会使用第三方软件或技术（包括本软件可能使用的开源代码和公共领域代码等。本软件如果使用了第三方的软件或技术，海能达将按照相关法规或约定，对相关的协议或其他文件，可能通过本协议附件、在本软件安装包特定文件夹中打包、或通过开源软件页面等形式进行展示。本软件所使用的第三方软件或技术，相关产权、版权及其它知识产权归原开发方所有。',
      line7: '1.3 软件许可',
      line8: '您需要获取海能达或经海能达认可的第三方的授权许可并缴纳相关软件使用许可费或其他费用后，方可合法使用本软件。本软件只能用于海能达公司的产品和服务上，且只能以海能达或经海能达认可的第三方明示许可的方式在被许可的对象、范围、数量、期限、版本内使用。任何将本软件使用于与海能达公司无关的产品和服务，或者超出海能达或经海能达认可的第三方的许可限制进行使用的行为，都是被禁止的。如您违反或不同意本协议下任何条款，您取得软件使用许可及相关权利将自动终止。海能达保留对任何人非法使用本软件的追责权利。',
      line9: '1.4 使用限制',
      line10: '不得修改：不得在非授权情况下修改、翻译或改编本软件，或基于本软件创作衍生作品。',
      line11: '不得用于非设计用途：不得以不符合本软件设计的方式来安装或使用本软件，包括规避内容保护技术，以及在非设计用于运行和使用本软件的计算机上使用本软件。',
      line12: '不得进行逆向工程：不得对有关软件的源代码进行逆向工程、反编译或试图以其他方式发现软件的源代码。',
      line13: '不得分发或转让：未经海能达公司授权，不得出售、分发、租赁、出租、发放子许可、让渡或转让本软件的权利，或者复制本软件。',
      line14: '1.5 管辖法律',
      line15: '本协议受中华人民共和国法律管辖。因本协议或其违约引起的或与之有关的任何争论或索赔，应由海能达公司所在地的有管辖权的法院管辖。海能达公司的知识产权如被侵犯，上述规定不限制海能达公司就此向具有合法管辖权的法院请求对您发出强制性的补救令。',
      line16: '1.6 责任限制',
      line17: '本软件产品以现状方式提供，海能达公司不保证本软件产品能够或不能够完全满足用户需求，在用户手册、帮助文件、使用说明书等软件文档中的介绍性内容仅供用户参考，不得理解为对用户所做的任何承诺。',
      line18: '在相关法律所允许的最大范围内，由您使用或不能使用本软件产品(包括但不限于营业利益的损失，营业中断，商业信息遗失，数据或代码损坏，程序运行出错、第三方知识产权追责)而造成损害的，您需独立承担相关损失并给对海能达或海能达供应商造成的损害作出补偿。',
      line19: '在您所在地的相关法律允许的情况下，上述限制和排除方可适用。本责任限制在某些国家可能无效，在此情况下，您可能依据消费者保护法和其他法律享有其他不得放弃的权利。',
      line20: '1.7 协议修改',
      line21: '如果本协议的部分条款无效或无法执行，不影响其余条款的有效和执行。本协议只能由海能达公司授权人员修改。未经海能达公司授权，不可以对本协议及其条款做修改和补充。',
      line22: '1.8 协议终止',
      line23: '如果您未遵守本协议的各项条款和条件，在不损害其它权利的情况下，海能达公司可随时终止本协议。如此类情况发生，您必须销毁本软件、及其所有副本及其全部组成部份。',
      line24: '1.9 其他',
      line25: '本协议不损害任何一方作为消费者的合法权益。本协议的修改须经海能达公司授权人员书面签署后方能生效。本协议是海能达公司与您之间有关本软件的完整协议，它将取代先前任何与本软件相关的陈述、讨论、承诺、通信或宣传。',
      line26: '如您对本软件许可协议有任何问题，或您因任何原因希望联络海能达公司，请使用随本产品附上的地址联络海能达公司，或在万维网上访问海能达公司，网址为：http://www.hytera.com。',
    }
  },
  Index: {
    exit: '退出',
    myAccount: '我的账号',
    custom: '个性化设置',
    about: '关于',
    version: '版本',
    pwdFreq: '密码更改过于频繁,密码修改间隔时间不得少于{0}分钟',
    help: '帮助'
  },
  Alarm: {
    alarmSocket: '实时告警',
    alarmOper: '告警处理',
    alarmManage: '告警管理',
    currentAlarm: '当前告警',
    historyAlarm: '历史告警',
    eventLog: '事件日志',
    blockingRule: '屏蔽规则',
    alarmNotice: '告警通知',
    alarmRedirect: '告警重定义',
    alarmID: '告警ID',
    alarmName: '告警名称',
    alarmLevel: '告警级别',
    alarmType: '告警类型',
    alarmDec: '告警描述',
    equipmentType: '设备类型',
    equipmentName: '设备名称',
    neType: '网元类型',
    neName: '网元名称',
    neAlarmFDN: '告警位置',
    clearState: '清除状态',
    confirmState: '确认状态',
    createTime: '产生时间',
    clearTime: '清除时间',
    confirmTime: '确认时间',
    clearUser: '清除人',
    confirmUser: '确认人',
    remark: '备注',
    messageNo: '流水号',
    xxdwinfo1: '详细定位信息1',
    xxdwinfo2: '详细定位信息2',
    xxkzinfo1: '详细扩展信息1',
    xxkzinfo2: '详细扩展信息2',
    xxkzinfo3: '详细扩展信息3',
    xxkzinfo4: '详细扩展信息4',
    cause: '告警产生原因',
    eventCause: '事件产生原因',
    advise: '修复建议',
    totalNumberOfAlarms: '总告警数量',
    numberOfCriticalAlarms: '紧急告警数量',
    numberOfMajorAlarms: '重要告警数量',
    numberOfMinorAlarms: '次要告警数量',
    numberOfWarningAlarms: '提示告警数量',
    refresh: '刷新',
    export: '导出',
    synchronize: '同步',
    confirm: '确认',
    clear: '清除',
    alarmDetails: '告警详细信息',
    statistics: '统计',
    shield: '屏蔽',
    filter: '过滤',
    alertSubscription: '告警订阅',
    automaticConfirmation: '自动确认',
    pleaseEnterTheQueryCriteria: '告警ID/告警名称/清除人/确认人',
    pleaseEnterAlmId: '请输入事件ID',
    eventId: '事件ID',
    sysDescription: '系统描述',
    sysType: '系统类型',
    eventLevel: '事件级别',
    eventType: '事件类型',
    neEventFDN: '事件位置',
    eventDes: '事件描述',
    eventSource: '事件源',
    brdType: '单板类型',
    cabinet: '柜号',
    frame: '框号',
    slot: '槽号',
    subSlot: '子槽号',
    advancedSearch: '高级查询',
    advancedSearchSetting: '高级搜索-条件设置',
    exportSetting: '数据导出-条件设置',
    eventSubscription: '事件订阅',
    rulename: '规则名称',
    starttime: '开始日期',
    endtime: '结束日期',
    status: '状态',
    add: '添加',
    remove: '删除',
    edit: '编辑',
    able: '启用',
    disable: '停用',
    notityform: '通知类型',
    notityinterval: '通知周期',
    notifyuser: '通知用户组',
    notifytemplate: '通知模板',
    notifystart: '开始时间',
    notifyend: '结束时间',
    notifyedit: '编辑时间',
    alarmAynchronize: '告警同步',
    alarmSource: '告警源',
    extraInfo: '附加信息',
    additionInfo: '补充信息',
    cancel: '取消',
    close: '关闭',
    filterSetting: '过滤条件设置',
    confirmSetting: '自动确认配置页面',
    confirmSettingParameter: '已选项参数不能为空',
    alarm: '告警',
    alarmNum: '告警总量',
    event: '事件',
    eventNum: '事件总量',
    singleNetwork: '单网元',
    neSelect: '网元选择',
    nodeSelect: '节点选择',
    pleaseChoose: '请选择',
    confirmCycle: '确认周期',
    minute: '分钟',
    hour: '小时',
    day: '天',
    thisDay: '今日',
    thisWeek: '本周',
    thisMonth: '今月',
    thisYear: '今年',
    notitylevel: '按级别通知',
    notityitem: '按告警项通知',
    notifytemplate1: '模板1',
    notifytemplate2: '模板2',
    byName: '按名称',
    byType: '按类型',
    redefine: '重定义',
    broadbandInquiry: '宽带查询',
    restoration: '复位',
    pleaseEnterAlarmDescription: '请输入告警描述',
    addRules: '添加规则',
    editRules: '修改规则',
    eventDetails: '事件详细信息',
    addBlockingRule: '添加屏蔽规则',
    editBlockingRule: '修改屏蔽规则',
    notificationRuleName: '通知规则名称',
    notificationTimeRule: '通知时间规则',
    notifyUserGroup: '通知用户组',
    methodToInforme: '通知方式',
    redefineModigy: '重定义修改',
    no_checked: '未选中任何数据',
    too_many_checked: '当前选中多条数据',
    startdatenull: '开始日期不能为空',
    enddatenull: '结束日期不能为空',
    datevalidate: '结束日期应大于开始日期',
    nenull: '告警源信息不能为空',
    alarmnull: '告警信息不能为空',
    notificationTimenull: '通知时间周期不能为空',
    alarmLevelnull: '告警级别不能为空',
    notificationMethodnull: '通知方式不能为空',
    notifyUserNotExist: '通知用户组不存在',
    fieldIsRequired: '该项不能为空',
    maxLength: '文字长度不能超过',
    notSingleQuoteOrBackslash: '不允许单引号或反斜杠',
    notInput: '不允许输入',
    minValueIs: '最小值为',
    maxValueIs: '最大值为',
    notInteger: '请输入有效的整数',
    notValidDate: '请输入有效的日期',
    success: '成功',
    error: '失败',
    syncSuccess: '同步成功',
    syncError: '同步失败',
    pleaseSelectNe: '请选择网元节点',
    pleaseSelectStartTime: '请选择开始时间',
    pleaseSelectEndTime: '请选择结束时间',
    EndTimeLessThanStartTime: '结束时间不能小于开始时间',
    enableconfirm: '确定要启用选中屏蔽规则吗',
    unenableconfirm: '确定要停用选中屏蔽规则吗',
    enableAlarmNoticeconfirm: '确定要启用选中告警规则吗',
    unenableAlarmNoticeconfirm: '确定要停用选中告警规则吗',
    alreadyModifiedSystem: '所有系统，全部修改成功',
    modifiedSystemFailed: '修改失败的系统',
    alarmredefned_1: '重定义级别',
    alarmredefned_2: '重定义描述',
    alarmredefned_3: '重定义级别/重定义描述',
    alarmredefned_4: '重定义修复建议',
    alarmredefned_5: '重定义修复建议/重定义级别',
    alarmredefned_6: '重定义修复建议/重定义描述',
    alarmredefned_7: '重定义修复建议/重定义描述/重定义级别',
    alarmLevel_3: '提示',
    alarmLevel_2: '次要',
    alarmLevel_1: '重要',
    alarmLevel_0: '紧急',
    alarmType_0: '设备',
    alarmType_1: '传输',
    alarmType_2: '业务',
    alarmConfirmStatus_0: '未确认',
    alarmConfirmStatus_1: '已确认',
    alarmClearStatus_0: '未清除',
    alarmClearStatus_1: '已清除',
    confirmGhost: '你确定要恢复吗？恢复后无法复原',
    ghostAllSystem: '所有系统，全部复位成功',
    fhostSystemFailed: '复位失败的系统',
    realTime: '实时',
    periodic: '周期性',
    alarmDeleteConfirm: '确认删除么?',
  },
  MML: {
    currentNode: '节点列表',
    moTree: 'Mo树',
    mml: 'MML',
    searchHolder: '输入并搜索...',
    ne: '网元',
    device: '设备',
    cluster: '集群',
    ue: 'UE',
    confirm: '确认',
    cancel: '取消',
    beginTime: '开始时间 :',
    endTime: '结束时间 :',
    mmlCommand: 'MML命令 :',
    mmlResponse: 'MML响应 :',
    operationCancelled: '连续两次执行失败，操作取消',
    noCheck: '请至少选择一条数据',
    atMost100: '最多选择100条数据',
    single: '单条',
    mass: '批量',
    execute: '执行',
    buildMML: '生成MML语句',
    history: '历史记录',
    fileName: '文件名',
    selectFile: '请选择TXT类型的文件',
    inputFileName: '请输入文件名并加后缀.txt',
    selectFileButton: '浏览',
    neType: '网元类型',
    notNull: '不能为空',
    maxBytesLength: '最大字节数为{0}',
    notValidIpv4: '请输入正确ipv4',
    notValidIpv6: '请输入正确ipv6',
    notValidTime: '请输入正确时间',
    notValidDate: '请输入正确日期',
    notValidInteger: '请输入整数',
    validRange: '有效范围是{0}',
    dangerOperTip: '该操作为高危操作，要继续进行吗？',
    noResult: '无',
    deleteAll: '删除全部',
    command: '命令行',
    validateFailed: '校验未通过',
    neOffline: '网元 {0} 不在线，无法进行MML配置。',
    execFailed: '执行失败，后台异常。',
    equipmentName: '设备名称：',
    elementName: '网元名称：',
    subnetInfo: '子网信息：',
    equipmentIp: '设备IP：',
    loadingTip: '加载中...'
  },
  MCS: {
    add: '添加',
    del: '删除',
    mod: '修改',
    dataBusiness: '数据业务',
    videoBusiness: '视频业务',
    voiceBusiness: '语音业务',
    groupList: '组呼列表',
    blackList: '黑名单',
    qry: '查询',
    export: '导出(按搜索条件)',
    groupMember: '组成员',
    groupCall: '呼叫区域',
    all: '全部',
    user: '用户',
    admin: '管理员',
    dc: '调度员',
    mobile: '车台',
    ordinaryUser: '普通用户',
    highUser: '高级用户',
    superUser: '超级用户',
    online: '在线',
    offline: '离线',
    working: '工作态',
    stun: '遥晕态',
    kill: '遥毙态',
    staticGroup: '静态组',
    dynamicGroup: '动态组',
    areaGroup: '区域组',
    userNum: '用户号码',
    participantType: '用户类型',
    userAlias: '用户别名',
    registerStatus: '在线状态',
    stunKillStatus: '遥晕遥毙状态',
    confirm: '确定',
    cancle: '取消',
    addUser: '新增用户',
    modUser: '修改用户',
    delUser: '删除用户',
    qryGroupList: '查询组呼列表',
    addBlackNum: '添加黑名单',
    manageBlackNum: '黑名单管理',
    superSearch: '高级搜索',
    chooseNe: '请选择网元!',
    onlyData: '请选择一条数据!',
    chooseData: '请选择数据！',
    choosed: '已选择',
    num: '项',
    addConfirm: '确认添加么?',
    deleteConfirm: '确认删除么?',
    userInfo: '用户信息',
    groupNum: '群组号码',
    groupType: '群组类型',
    groupAlias: '组别名',
    groupOwner: '组所有者',
    messageInfo: '日志',
    addGroup: '新增群组',
    modGroup: '修改群组',
    addGroupMember: '添加组成员',
    groupMemberManage: '组成员管理',
    gpsGroupCallManage: '呼叫区域管理',
    userPriority: '用户优先级',
    userPrivilege: '用户特权',
    inputLng: '请输入经度(度)',
    inputLat: '请输入纬度(度)',
    locate: '定位',
    neOffLine: '网元不在线',
    insertNum: '请输入数字',
    rangeLat: '请输入[-180,180]的经度',
    rangeLng: '请输入[-90,90]的纬度',
    openDrawMode: '打开绘图模式',
    closeDrawMode: '关闭绘图模式',
    chooseAreaGroup: '非区域组不能设置呼叫区域',
    require: '该项不能为空',
    numAt63: '请输入0-63位数字',
    charAt63: '请输入63位以内字符',
    passwordEqual: '密码与确认密码要保持一致',
    numOrChar: '请输入数字或英文',
    noSpecialChar: '不允许输入特殊字符',
    dcWarn: '调度台用户不能设置为转移号码',
    refresh: '刷新',
    zoomIn: '放大',
    zoomOut: '缩小',
    nozonegrp: '区域开关关闭时不允许设置区域组',
  },
  Track: {
    signManage: '信令管理',
    signTrack: '信令跟踪',
    userTrack: '用户跟踪',
    monitorTrack: '任务监控',
    importTrackData: '信令数据导入',
    NElist: '网元列表',
    resourcesList: '资源列表',
    taskList: '任务列表',
    refreshTask: '刷新任务',
    addTask: '添加任务',
    activationTask: '激活任务',
    suspendTask: '挂起任务',
    missionCompleted: '完成任务',
    taskDeletion: '删除任务',
    taskDetails: '任务详情',
    taskTracking: '任务跟踪',
    downloadFile: '下载文件',
    pleaseEnterQuery: '请输入查询条件',
    taskName: '任务名称',
    neId: '网元ID',
    taskStatus: '任务状态',
    creatTime: '创建时间',
    startTime: '开始时间',
    endTime: '结束时间',
    result: '执行结果',
    greate: '待执行',
    tracing: '执行中',
    createTask: '创建任务',
    confirm: '确认',
    cancel: '取消',
    measuringObject: '测量对象',
    pleaseSelectMeasuringObject: '请选择测量对象',
    pleaseSelectNE: '请选择资源',
    taskID: '任务ID',
    trackingCommunity: '跟踪小区',
    publicMessage: '公共消息',
    internalSignaling: '内部信令',
    standardInterface: '标准接口',
    signalingDetails: '信令详情',
    close: '关闭',
    search: '查询',
    all: '全部',
    activation: '激活',
    complete: '完成',
    importFileError: '导入文件错误',
    queryTrack: '信令查询',
    import: '导入',
    export: '导出',
    noDataToExport: '没有数据无法导出',
    fieldIsRequired: '该项不能为空',
    fileName: '文件名称',
    add: '添加',
    active: '执行',
    stop: '暂停',
    hangup: '挂起',
    finish: '完成',
    delete: '删除',
    detail: '详情',
    mission: '跟踪',
    download: '下载',
    notGenerated: '未生成相关文件',
    queryError: '查询错误',
    taskInProgress: '任务正在执行中',
    taskIsPending: '任务处于挂起状态',
    missionAlreadyCompleted: '任务已经完成',
    deleteTaskInfo: '删除任务会同时删除相关的上报文件，是否删除该任务？',
    success: '成功',
    error: '失败',
    autoActivationFailed: '自动激活失败',
    searchNe: '搜索网元',
    searchResource: '搜索资源',
    resourceID: '资源ID',
    resourceName: '资源名称',
    resourceType: '资源类型',
    endTimeGreaterThanStartTime: '结束时间应大于开始时间',
    neName: '网元名称',
    time: '时间',
    operating: '操作',
    signalDataExport: '信令数据导出',
    systemId: '系统ID',
    reportType: '上报类型',
    realTime: '实时',
    file: '文件',
    taskTypeID: '模版ID',
    taskSrc: '任务来源',
    messageType: '消息类型',
    struct: '结构体',
    text: '文本',
    status: '状态',
    implementation: '执行中',
    systemOutTime: '系统连接超时',
    save: '保存',
    issued: '待下发',
    reIssued: '重新下发',
    pleaseSelect: '请选择',
    filterConditions: '过滤条件',
    attributeName: '属性名称',
    expression: '表达式',
    attributeValues: '属性值',
    filter: '过滤',
    historyFilter: '历史过滤',
    realTimeFiltering: '实时过滤',
    deleteFile: '是否删除文件？'
  },
  Security: {
    inputRoleName: '请输入角色名称',
    add: '新增',
    delete: '删除',
    modify: '修改',
    active: '激活',
    success: '成功',
    failure: '失败',
    securityManage: '安全管理',
    authorityManage: '权限管理',
    userManage: '用户管理',
    roleManage: '角色管理',
    logManage: '日志管理',
    loginLog: '登录日志',
    operateLog: '操作日志',
    strategyManage: '策略管理',
    userStrategy: '用户策略',
    pwdStrategy: '密码策略',
    timeStrategy: '时间策略',
    LicenseManage: 'License管理',
    device: '设备',
    strategyNameExist: '策略名称已存在',
    clientRules: '地址规则',
    User: {
      username: '用户名称',
      realname: '真实名称',
      password: '用户密码',
      confirmpwd: '确认密码',
      phone: '电话',
      email: '邮箱',
      status: '状态',
      start: '启用',
      abandon: '停用',
      desc: '描述'
    },
    Role: {
      name: '角色名称',
      createTime: '创建时间',
      creator: '创建人',
    },
    Strategy: {
      name: '策略名称',
      startDate: '起始日期',
      endDate: '终止日期',
      startTime: '起始时间',
      endTime: '终止时间',
      weekday: '星期',
      date: '日期',
      time: '时间',
      sunday: '星期日',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      to: '至',
      accountMinNumber: '账户最小字符个数',
      accountLock: '账户锁定策略',
      lockPeriod: '指定时间段长度(分钟)',
      failTimes: '限定时间段内连续登陆失败次数',
      lockTime: '锁定时长(分钟)',
      lockOn: '永久锁定',
      pwdMinNumber: '密码最小字符个数',
      shortInterval: '密码修改最短时间间隔(分钟)',
      constitute: '密码组成',
      onlyNumChar: '只包含数字和字母',
      special: '至少包含一个特殊字符:!#$%&*+-/<=>?@[\\]^{_}~',
      updPwd: '过期时强制更改密码',
      pwdPeriod: '密码有效期',
      remindDay: '在到期前几天通知密码更改',
      updTipInfo: '策略修改后，将在用户下次登录时生效。'
    },
    "Log": {
      "loginResult": "登录结果",
      "loginTime": "登录时间",
      "module": "模块",
      "feature": "功能",
      "result": "执行结果",
      "execType": "执行类型",
      "execTime": "执行时间"
    },
    client: {
      startAddress: '起始地址',
      endAddress: '终止地址',
      addClient: '新增规则',
      editClient: '修改规则'
    },
    placeholder: {
      username: '请输入账户名称',
      realname: '请输入真实名称',
      password: '请输入用户密码',
      confirmpwd: '请输入确认密码',
      mail: '请输入邮箱',
      phone: '请输入电话',
      strategyName: '请输入策略名称',
      inputInteger: '请输入整数',
      startAddress: '请输入起始地址',
      endAddress: '请输入终止地址'
    },
    auth: {
      ne: '网元分域',
      fun: '功能权限',
      search: '网元检索'
    },
    validate: {
      email: '请输入有效的电子邮件地址',
      minLength: '请输入至少{0}个字符',
      maxLength: '请输入少于{0}个字符',
      noSpecial: '请输入数字字母组合',
      special: '请输入至少包含一个特殊字符的组合',
      phone: '电话号码格式错误',
      ip: 'IP地址格式错误',
      addressRangeErr: 'IP地址不在相同地址段',
      addressCompareErr: '起始IP应小于终止IP'
    },
    Lic: {
      esn: 'ESN',
      uploadStatus: '上传状态',
      uploadTime: '上传时间',
      activeStatus: '激活状态',
      activeTime: '激活时间',
      licenseDetail: 'License详情',
      activeLicense: '请先激活设备License',
      uploadStatus_uploaded: '已上传',
      uploadStatus_unupload: '未上传',
      activeStatus_activated: '已激活',
      activeStatus_inactivated: '未激活',
      syncDevLicense_warntip : '只能同步未上传过license的设备',
      activeLicense_warntip:'设备license已经激活，不能操作',
      activeLicense_warntip1:'请先上传设备license'
    },
    pwdNotMatch: '密码与确认密码不一致',
    addUser: '新增用户',
    editUser: '修改用户',
    userInfo: '用户信息',
    authInfo: '权限信息',
    roleInfo: '角色信息',
    addRole: '新增角色',
    editRole: '修改角色',
    addTimePolicy: '新增时间策略',
    editTimePolicy: '修改时间策略',
    selectDate: '选择日期',
    userExist: '用户已存在',
    deleteLog: '删除数据库记录之前，请检查导出的日志',
    exportTimeNotNull: '导出时间不能为空',
    roleNameNotNull: '角色名不能为空',
    roleNameExists: '角色已存在',
    selectTimePolicy: '请选择时间策略',
    defaultPolicyNotDel: '默认策略禁止删除',
    defaultPolicyNotEdit: '默认策略禁止编辑',
    dateNotNull: '日期不能为空',
    dateCompare: '起始日期不能大于结束日期',
    timeNotNull: '时间不能为空',
    timeCompare: '起始时间不能大于结束时间',
    weekNotNull: '星期不能为空',
    EadminCannotModify: 'Eadmin角色不允许修改',
    EadminCannotDelete: 'Eadmin角色不允许删除',
  },
  Software: {
    td_neName: '设备类型',
    td_taskType: '任务类型',
    td_operationType: '操作类型',
    td_fileName: '文件名称',
    td_progress: '进度',
    td_status: '状态',
    td_result: '结果',
    td_createTime: '创建时间',
    td_executionTime: '计划执行时间',
    td_detail: '详情',
    netask: '设备任务',
    opetask: '操作任务',
    download: '下载',
    active: '激活',
    rollback: '切换',
    DlandAt: '下载；激活',
    DlandAtandUl: '下载；激活；上载',
    AtandUl: '激活；上载',
    DlandUl: '下载；上载',
    RbandUl: '切换；上载',
    // upload: '上载',
    success: '成功',
    fail: '失败',
    partSucc: '部分成功',
    progressing: '执行中',
    waitforexe: '等待执行',
    notstart: '未开始',
    done: '已结束',
    td_packageName: '升级包名',
    td_packageTag: '软件包标签',
    td_packageVer: '版本号',
    updataOper: '升级操作',
    filter: '过滤',
    dataUpload: '数据上载',
    caution: '注意：选择“激活”设备将重启',
    import: '导入',
    export: '导出',
    delete: '删除',
    refresh: '刷新',
    exporttemplate: '导出模板',
    exportdata: '导出数据',
    devicegroupname: '设备组名称',
    subnetmask: '子网掩码',
    gateway: '网关',
    startipaddr: '起始IP',
    endipaddr: '终止IP',
    description: '描述',
    pleaseEnterTheQueryCriteria: '请输入查询条件',
    no_checked: '未选中任何数据',
    too_many_checked: '当前选中多条数据',
    tscipautodistribute: '基站IP自动分配',
    pocupgrade: 'Poc升级',
    upgrademanage: '软件管理',
    storeversion: '存储版本',
    runversion: '运行版本',
    td_neID: '设备名称',
    td_mainPkgVer: '基准版本号',
    td_isSupportMS: '是否支持主备',
    td_isSupportRbk: '是否支持切换',
    td_pkgStatus: '版本包状态',
    query_remarks: '说明',
    query_cabinetId: '柜号',
    query_frameId: '框号',
    query_slotId: '槽号',
    query_appVersion: '软件版本',
    td_taskId: '任务编号',
    backcaution: '注意：确认后设备将重启',
    vmyes: '是',
    vmno: '否',
    reserved: '备用',
    running: '运行',
    common: '公共',
    appupdate: 'APP软件管理',
    nename: '网元名称',
    versionNo: '版本号',
    versionName: '版本名称',
    uploader: '上传人',
    uploadtime: '上传时间',
    notifystatus: '通知状态',
    downloadstatus: '下载状态',
    versiondescription: '版本描述',
    MD5Code: 'MD5',
    ExecuteFile: '执行文件',
    uploaderStr: '上传人',
    add: '添加',
    close: '关闭',
    selectDeviceGrp: '请选择设备组',
    exportTemplateTip: '确认导出窗模板？',
    deleteTip: '确认删除?删除后不可恢复！',
    uploadExcel: '上传',
    cancel: '取消',
    enterKeywordSearch: '请输入网元名称进行搜索',
    onlyReserveAllowed: '只能激活版本包为备用状态的版本',
    downloading: '下载中',
    downloadFailure: '未下载',
    downloadSuccess: '下载成功',
    informed: '已通知',
    unInformed: '未通知',
    save: '保存',
    pleaseUploadFile: '请上传文件',
    MD5CheckFail: 'MD5校验失败',
    POCUpgrade: 'MPTT上传',
    MCSUpgrade: 'MCC上传',
    AddPOCVersion: '上传MPTT软件包',
    AddMCSVersion: '上传MCC软件包',
    dl_noneed: '不需下载',
    dl_already: '已存在',
    dl_succ: '下载成功',
    dl_fail: '下载失败',
    pkgType: '版本包类型',
    pkgMode: '版本模式',
    upload: '上传版本包',
    addtask: '添加升级任务',
    redo: '重新开始',
    updManage: '升级管理',
    lte_udp_version: '版本升级',
    softManage_Upd: '软件管理/版本升级',
    downloadtasklist: '下载任务列表',
    softManage_Lib: '软件管理/版本库管理',
    softManage_back: '软件管理/版本切换',
    rb_version: '版本切换',
    que_version: '软件管理/版本查询',
    queVersion: '查询版本中',
    up_fail: '上传失败',
    upda_fail: '升级失败',
    bak_fail: '切换失败',
    RequiredLength: '输入数据长度应该为',
    Uploading: '文件正在上传...',
    Searching: '查询中...',
    deviceNotExistInfo: '没有对应的设备进行升级!',
    validateInputInfo: '输入数据有误,请检验',
    selectOprObj: '请选择操作对象',
    selectOprType: '请选择操作类型',
    softManage_Automantic: '软件管理/基站IP自动分配',
    softManage_AppUpgrade: '软件管理/APP软件管理',
    selectAtLeastOne: '请选择至少一条数据!',
    dataIsLoading: '数据正在加载...',
    DHCPIsLoading: 'DHCP数据正在加载...',
    pleaseSelectNe: '请选择网元',
    allocated: '已分配',
    nonallocated: '未分配',
    selectDevice: '请选择设备',
    messionExist:'存在正在执行的任务',
    queryAppSoftwareInfo: '查询APP管理信息',
    serialNumber: '电子序列号',
    ipAddress: 'IP地址',
    distributionState: '分配情况'
  },
  Topo: {
    devEPC: 'EPC服务器',
    devhytalkPro: 'HyTalk Pro',
    devMCS: 'MCS服务器',
    deveNodeB: 'eNodeB',
    deveNodeBIOPS: 'eNodeB-IOPS',
    deviBS: 'iBS',
    deviBSB: 'iBS-B',
    devODBBU: 'ODBBU',
    devgNB: 'gNB',
    devhytalk: 'HyTalk',
    addDev: '新增设备',
    devID: '设备ID',
    devName: '设备名称',
    devType: '设备类型',
    editDev: '修改设备',
    delDev: '删除设备',
    devSoftVersion: '软件版本',
    devDescription: '设备描述',
    devManager: '设备管理',
    devIpPort: '通信IP&通信端口',
    devIp: '通信IP',
    devPort: '通信端口',
    devThread: '进程号',
    devSelect: '请先选择设备类型',
    devAttriSelect: '请先选择归属设备',
    devAttriTrunk: '归属集群',
    devAttriSubnet: '请选择归属子网',
    devCrumb: '拓扑管理/资源管理/设备管理',
    devAdd: '添加设备',
    devMange: '设备管理',
    devModify: '修改设备',
    netTypeImg: '网元图例',
    physicalIP: '物理IP',
    physicalPort: '物理端口',
    serveDetail: '服务详情',
    saveTopo: '保存拓扑',
    excelLayout: '表格布局',
    revertScale: '恢复1:1',
    fullScreen: '全屏',
    selectAll: '全选',
    backPrevious: '返回上一级',
    addNe: '新增网元',
    editNe: '修改网元',
    delNe: '删除网元',
    neName: '网元名称',
    neType: '网元类型',
    neID: '网元ID',
    neDev: '归属设备',
    neManager: '网元管理',
    cummunicateIPPort: '通信IP和端口',
    cummunicateIPPortPSelected: '请选择通信IP和端口',
    neDescription: '网元描述',
    neMME: 'MME',
    neHSS: 'HSS',
    nePGW: 'PGW',
    neSGW: 'SGW',
    nePCRF: 'PCRF',
    neTCF: 'TCF',
    neTMF: 'TMF',
    nePDTGW: 'PDTGW',
    neDBS: 'DBS',
    neMC_CMS: 'MC_CMS',
    neMC_CF: 'MC_CF',
    neMC_GMS: 'MC_GMS',
    neMC_IDMS: 'MC_IDMS',
    neMC_PF: 'MC_PF',
    neBM_SC: 'BM-SC',
    neMBMS_GW: 'MBMS-GW',
    neFRS: 'FRS',
    neMC_TMF: 'MC_TMF',
    nePRES: 'PRES',
    neP_HSS: 'P_HSS',
    neMC_KMS: 'MC_KMS',
    neMCE: 'MCE',
    nePCDR: 'PCDR',
    neDMS: 'DMS',
    neMC_GMS_NODE: 'MC_GMS_NODE',
    neeNodeB: 'eNodeB',
    neODBBU: 'ODBBU',
    neiBS_B: 'iBS-B',
    neCU: 'CU',
    neDU: 'DU',
    neSelect: '请选择网元类型',
    neDevSelect: '请先选择归属集群',
    addTrunk: '新增集群',
    trunkName: '集群名称',
    trunkCode: '集群类型',
    editTrunk: '修改集群',
    delTrunk: '删除集群',
    trunkManager: '集群管理',
    trunkDescription: '集群描述',
    neList: '网元列表',
    trunkNelist: '挂载网元',
    trunkMC_CF: 'MCS',
    trunkHyTalk: 'HyTalk',
    // trunkMC_PF: 'MC_PF',
    // trunkMC_TMF: 'MC_TMF',
    trunkSelect: '请先选择集群类型',
    addSubnet: '新增子网',
    subnetID: '子网ID',
    subnetType: '子网类型',
    subnetName: '子网名称',
    subnetDes: '子网描述',
    subnetMan: '子网管理',
    updateSubnet: '修改子网',
    deleteSubnet: '删除子网',
    parentNode: '父节点',
    childNode: '子节点',
    ipIllegal: '请输入合法IP',
    portIllegal: '范围应为1024-65535',
    success: '成功',
    error: '失败',
    sureDel: '确定要删除吗？',
    delSuccess: '删除成功',
    pleaseSelect: '请选择数据!',
    pleaseSelectOne: '请选择一条数据!',
    neCrumb: '拓扑管理/资源管理/网元管理',
    neAdd: '添加网元',
    neMange: '网元管理',
    neModify: '修改网元',
    trunkCrumb: '拓扑管理/资源管理/集群管理',
    trunkAdd: '添加集群',
    trunkMange: '集群管理',
    trunkModify: '修改集群',
    noData: '没有数据',
    search: '搜索',
    addSuccess: '添加成功',
    modifySuccess: '修改成功',
    noSelectTrunk: '该设备类型不允许选择归属集群',
    noAttriTrunk: '不归属任何集群',
    ipPortDup: 'IP和端口重复',
    invalidInt: '请输入整数',
    inputRangeIllegal: '输入值必须在1到65535之间',
    noAddMore: '不能再添加了',
    forbidDel: '此IP和端口不允许删除',
    subnetNumFour: '子网层级最多为4层',
    emptySubnet: '不能创建空子网',
    noEmptyStart: '名称禁止用空格开头',
    permissionDenied: '无权限',
    elementTree: '网元树',
    topoManagerAndTopoMonitor: '拓扑管理/拓扑监控',
    confirm: '确定',
    cancel: '取消',
    devBelongSubnet: '归属子网',
    topoManager: '拓扑管理',
    topoRack: '机架图',
    topoLoad: '加载..',
    topoSearchEquipment: '搜索设备',
    topoRerefresh: '刷新列表',
    equipmentList: '设备列表',
    invalidIPAddress: '无效的IP地址。例如：192.168.69.1',
    neTypeForSubnet: '网元类型',
    topoMaxLength: '文字长度不能超过',
    nodeId: '节点ID',
    nodeType: '节点类型',
    nodeName: '节点名称',
    mountNode: '挂载节点',
    refresh: '拓扑结构发生变化，即将刷新页面',
    pleaseEnterDeviceName:'请输入设备名称',
    pleaseEnterNeName:'请输入网元名称',
    longitude: '经度',
    latitude: '纬度',
    altitude: '海拔高度',
    longitudePlaceholder: '请输入经度-180~180',
    latitudePlaceholder: '请输入纬度-90~90',
    altitudePlaceholder: '请输入海拔高度-9999~9999',
    longitudeIllegal: '输入值必须在-180到180之间',
    latitudeIllegal: '输入值必须在-90到90之间',
    altitudeIllegal: '输入值必须在-9999到9999之间',
    subnetFilterPlaceHolder: '节点类型 /节点名称',
    deviceSubnetTips:'请先新增子网并且分配权限'
  },
  System: {
    // SystemManager
    deleteFile: '文件正在删除...',
    uploadingFile: '文件正在上传...',
    zipTip: '版本包格式不正确',
    epcOAM: 'EPC平台',
    imsOAM: 'IMS平台',
    mcsOAM: 'MCS平台',
    enodeb: 'eNodeB',
    ibs_b: 'iBS-B',
    ims_hytalk: 'IMS_HYTALK平台',
    mcscl: 'MCSCL平台',
    ftpAddress: 'FTP地址',
    ftpPort: 'FTP端口',
    ftpUser: 'FTP用户名',
    ftpPassword: 'FTP密码',
    ftpTest: 'FTP测试',
    ftpAddressTip: '例如:192.168.1.1',
    ftpAddressNotNull: 'FTP地址不能为空',
    ftpPortTip: '1~65535',
    ftpPortNotNull: 'FTP端口号不能为空',
    neOAM: 'OAM',
    missManager: '任务管理',
    systemMiss: '系统任务',
    customMiss: '自定义任务',
    missList: '任务列表',
    missLogs: '任务日志',
    createTask: '创建定时任务',
    taskFilter: '高级搜索',
    taskSearchKey: '输入任务ID或任务名称',
    delTask: '删除定时任务',
    activeTask: '激活',
    deactiveTask: '暂停',
    editTask: '修改任务',
    taskId: '任务ID',
    taskName: '任务名称',
    isEffective: '是否生效',
    state: '当前状态',
    oprType: '操作类型',
    module: '模块',
    startTime: '开始时间',
    endTime: '结束时间',
    nextTime: '下次时间',
    lastResult: '最近结果',
    description: '描述',
    result: '执行结果',
    reSuccess: '成功',
    reFault: '失败',
    confirm: '确定',
    cancel: '取消',
    close: '关闭',
    tip: '提示',
    yes: '是',
    no: '否',
    pleaseChoose: '请选择',
    isRunning: '正在执行',
    isReady: '准备就绪',
    isInvalid: '过期',
    mmlMiss: 'MML任务',
    taskPastDue: '任务已过期',
    db: 'DB',
    systemFile: '系统文件',
    config: '配置',
    fm: '性能',
    alarm: '告警',
    spectrum:'扫频',
    systemManager: '系统管理',
    pause: '暂停',
    selectOneMessage: '请选择一条数据',
    selectMessages: '请选择数据',
    groupExists: '用户组已存在',
    userExists: '用户已存在',
    confirmDel: '确认删除',
    export: '导出',
    searchC: '搜索分类',
    timeRange: '时间范围',
    serialNumber: '流水号',
    level: '等级',
    runTime: '执行时间',
    selectTimeRange: '请选择时间范围',
    backupDays: '备份天数',
    backupNum: '备份条数',
    resultNotice: '结果通知',
    runCycles: '执行周期',
    runCyclesTip: '选择执行周期才展示下面区块的表单',
    every: '每',
    minute: '分钟',
    hour: '小时',
    day: '天',
    month: '月',
    week: '星期',
    weeks: '周',
    ri: '日',
    everyWeekend: '每个工作日',
    geYueDi: '个月第',
    geWeek: '个星期',
    remarks: '备注',
    selectFile: '选择文件',
    selectFileTip: '只能上传.txt文件，且不超过1MB',
    inputTip: '请输入内容',
    uerNameNotNull: '用户名不能为空',
    fileNotNull: '文件不能为空',
    timeRangeNotNull: '时间间隔不能为空',
    dayRangeInvalid: '天间隔应该在1-31内',
    hourRangeInvalid: '小时间隔应该在1-23内',
    minuteRangeInvalid: '分钟时间隔应该在1-59内',
    endDateInvalid: "结束时间应大于开始时间",
    sixMonth:"6月",
    oneYear:"1年",
    threeYear:"3年",
    forever:"持久保存",
    // dataManager
    selectOprSet: '选择操作集合',
    busSet: '业务操作',
    inputTip1: '输入项名称、表名、创建时间',
    itemName: '项名称',
    tableName: '表名称',
    updateTime: '更新时间',
    neType: '网元类型',
    dataTotal: '数据总量(条)',
    createTime: '创建时间',
    editTime: '编辑时间',
    area: '占用空间(MB)',
    dataManager: '数据管理',
    busManager: '业务数据管理',
    resultTip: '结果',
    backDelTime: '备份时间或删除时间不能为空',
    backDelRange: '备份容量或删除容量不能为空',
    node: '网元',
    resource: '资源',
    alarmType: '类别',
    curAlarmData: '当前告警数据',
    hisAlarmData: '历史告警数据',
    busData: '事件数据',
    runOpr: '执行操作',
    missResol: '错误处理',
    backupName: '备份名称',
    backupType: '备份类型',
    inputTip2: '1-255个英文字符',

    onlyBackup: '备份',
    onlyDel: '删除',
    backupAndDel: '备份并删除',
    acTime: '按时间',
    acArea: '按容量',
    continueRun: '继续执行',
    stopRun: '终止执行',
    localSave: '本地保存',
    remoteSave: '远端保存',
    bothSave: '同时保存',
    beforeDay7: '7天前',
    beforeDay15: '15天前',
    beforeDay30: '30天前',
    num1000: '1000条',
    num3000: '3000条',
    num5000: '5000条',
    num10000: '10000条',
    backupTime: '备份时间',
    inputTip3: '执行n天前的记录',
    backupArea: '备份容量',
    inputTip4: '执行n条前的数据',
    delTime: '删除时间',
    delArea: '删除容量',
    inputTip5: '删除n天前的记录',
    inputTip6: '删除n条前的数据',
    oprTime: '操作时间',
    oprArea: '操作容量',

    addPkg: '添加版本包',
    add: '添加',
    delete: '删除',
    inputTip7: '请输入关键字进行搜索',
    productType: '产品类型',
    productEle: '下属网元及平台',
    productVersion: '产品版本',
    changeTime: '修改时间',
    upFileTip: '只能上传zip文件，不超过500M',
    delPkgTip: '确认删除版本包吗?',
    pkgManager: '版本包管理',
    uploadFile: '开始上传',
    selectDelObj: '请选择删除对象',
    addPkgObj: '请添加适配包',

    mailTip: '提示：设置本系统与邮箱服务器对接参数，以建立两者间通信。当启用邮件通知功能后，系统自动发送邮件通知用户。为了保证发送邮件的安全性，推荐采用SSL/TLS(Secure Sockets Layer)安全连接',
    inputTipIp: '请输入IP',
    mailAccount: '邮箱账号',
    smtpTip: 'SMTP服务器域名/IP地址',
    inputTipEmail: '请输入正确的邮箱地址',
    sslTlsTip: 'SMTP服务器请求SSL/TLS安全连接（请先确认邮箱服务器SSL/TLS证书已安装完成）',
    inputTipPort: '请输入端口号',
    port: '端口',
    smtpCheckTip: 'SMTP服务器要求身份验证（SMTP服务器访问控制为"基本身份验证"时，需启用该选项）',
    testLoading: '正在测试服务器能否接通...',
    userCheck: '验证用户名',
    passwordCheck: '验证密码',
    reset: '重置',
    test: '测试',
    apply: '应用',
    systemNotice: '系统通知',
    serviceSet: '服务器设置',
    invalidIp: '无效的IP地址',
    emailNotNull: '请输入邮箱地址',
    inputNumber: '请输入数字',
    inputInteger: '请输入整数',
    sendEmailTime: '邮件发送时间',
    sendResult: '发送结果',
    emailTitle: '邮件标题',
    timeTaskId: '定时任务id',
    emailQuery: '邮件查询',

    addressBook: '通讯录',
    user: '用户',
    uGroup: '用户组',
    createUserInfo: '创建用户信息',
    editUserInfo: '编辑用户信息',
    change: '修改',
    fGroup: '所属用户组',
    telephone: '手机号码',
    email: '邮件地址',
    createGroupInfo: '创建用户组信息',
    userGroupName: '用户组名',

    remoteTip: '远程通知需要设置对应的远程通知用户组。你可以增加、修改或删除用户.',
    inputUser: '请输入用户名',
    optionalUser: '可选用户',
    selectedUser: '已选用户',
    userGroupNotNull: '用户组名不能为空',
    telephoneOrEmail: '请输入邮箱和手机号码其中的至少一项.',
    systemName: '系统名称',
    save: '保存',
    systemLogo: '系统logo',
    pngTip: '只能上传png文件，且不超过2MB，尺寸83x35像素.(建议图片背景透明)',
    systemSet: '系统设置',
    personal: '个性化',
    loginAgain: '请重新登录',
    uploadSuccess: '上传成功',
    uploadFault: '上传失败',
    rowDataNum: '行数据条数(条)',
    dataLength: '数据长度(M)',
    indexLength: '索引长度(M)',
    tableCreateTime: '表创建时间',
    tableUncode: '表的字符校验编码集',
    oprName: '操作名称',
    dataNameOrFtpPath: '数据名称或FTP路径',
    takeTime: '耗时',
    takeTimeWithUnit: '耗时(秒)',
    maxLayer: '最大图层',
    minLayer: '最小图层',
    defaultLayer: '默认显示图层',
    centerLon: '地图中心经度',
    centerLat: '地图中心纬度',
    copyright: '版权信息',
    input1t15: '请输入1-15的正整数',
    centerLonInput: '请输入地图中心的经度',
    centerLatInput: '请输入地图中心的纬度',
    copyrightInput: '请输入地图版权信息',
    mapConfig: '地图配置',
    mapLngLimit: '请输入合法的精度,精度范围 [-180,180]',
    mapLatLimit: '请输入合法的纬度,纬度范围 [-90,90]',
    detailLog: '详细日志',
    saveMapSuccess: '保存成功',
    // 个性化
    uploadConfirm: '是否确认上传',
    uploadImgWith: '83',
    uploadImgHeight: '35',
    uploadTipsWidth: '上传图片宽度不能超过83像素',
    uploadTipsHeight: '上传图片高度不能超过35像素',
    uploadTipsSize: '上传图片不能超过2MB',
    loading: '加载中...',
    processing: '处理中...',
    CPUUsage: "CPU使用率(%)",
    MemoryUsage: "内存使用率(%)",
    DiskUsage: "磁盘使用率(%)",
    ThresholdConfig: "网管资源阈值配置"
  },
  TS: {
    trafficMeasurement: '话务统计',
    callServiceStatistics: '呼叫业务统计',
    callFailureCountStatistics: '呼叫失败数统计',
    callSetUpTimeStatistics: '呼叫平均建立时长统计',
    trafficTaskManagement: '任务管理',
    neName: '网元名称',
    neID: '网元ID',
    taskName: '任务名称',
    taskDetail: '任务描述',
    taskState: '任务状态',
    taskState_0: '暂停',
    taskState_1: '执行',
    opTime: '操作时间',
    operation: '操作',
    starttime: '开始日期',
    endtime: '结束日期',
    interval: '时间间隔',
    startDateIsNull: '开始日期不能为空!',
    endDateIsNull: '结束日期不能为空！',
    startDateGreaterEndDate: '开始日期不能大于结束日期!',
    neIDIsNull: '请选择网元',
    startDateEqualsEndDate: '请选择的开始日期与结束日期相同!',
    startDateNoEqualsEndDate: '开始日期与结束日期不能相同!',
    startDateMaxEndDate: '最大支持查询31天!',
    time15min: '15分钟',
    time1hour: '1小时',
    time1day: '1天',
    alertMessage: '提示',
    singleCallSetUpTime: '单周期呼叫建立时长次数',
    configTime: '呼叫建立时长区间',
    configTimeRange: '呼叫建立时长区间边界值',
    ts_ok: '确定',
    ts_cancell: '取消',
    ts_search: '查询',
    gs_search: '高级搜索',
    callSetUpTimeCount: '呼叫建立时长数量',
    callCount: '呼叫总数',
    callFailedCount: '呼叫失败数',
    singleCallFailedCount: '单周期呼叫失败数',
    ts_chart_atleast_two_numbers: '至少输入两个数!',
    ts_chart_illegal_number: '非数值!',
    ts_chart_firstNumber_bigerthan0: '数字必须大于0!',
    ts_chart_xAxis_positive_integer: '请输入正整数！',
    ts_number_not_null: '中间数值不能为空!',
    ts_back_must_larger_than_pre: '后一个值必须大于前一个值!',
    ts_chart_single_call: '语音单呼',
    ts_chart_group_call: '语音组呼',
    ts_chart_single_video: '视频单呼',
    ts_chart_group_video: '视频组呼',
    ts_chart_broadcast_call: '广播呼叫',
    selectNeIDIsNull: '请在搜索框中选择网元',
    ts_task_oper_start: '开始',
    ts_task_oper_stop: '暂停',
    ts_call_task_name: '语音任务',
    ts_call_task_describer: '语音信息上报',
    ts_reg_task_name: '注册任务',
    ts_reg_task_describer: '注册信息上报',
    ts_xAxis: 'X坐标',
    ts_neList: '网元列表',
    ts_count: '数量',
    ts_average_time: '平均建立时长(毫秒)',
    ts_xAxis_time: '时间',
    ts_call_type: '呼叫类型',
    ts_call_setup_time: '单周期呼叫建立时长(毫秒)',
    ts_have_stop_task: '任务已经处于暂停状态！',
    ts_have_start_task: '任务已经处于执行状态！',
    success: '成功',
    ts_cannot_operate: '不能进行此操作！',
    ts_neOffLine: '网元不在线！',
    ts_fail: '操作失败！'
  },
  PDN: {
    nelist: '网元列表',
    pleaseSelectNE: '请选择网元',
    crumb: '开户管理/LTE管理/PDN模板',
    add: '增加',
    modify: '修改',
    remove: '删除',
    refresh: '刷新',
    pgwEnableLabel: '使用签约PGW',
    pgwAddrLabel: 'PGW地址',
    pgwHostLabel: 'PGW主机',
    addProfile: '新增模板',
    modProfile: '修改模板',
    confirm: '确定',
    cancel: '取消',
    success: '成功',
    failed: '失败',
    ipv4: 'IPv4',
    ipv6: 'IPv6',
    doubleStack: '双栈',
    preemptable: '可抢占',
    preemptedable: '可被抢占',
    noPreemptable: '不可抢占',
    noPreemptedable: '不可被抢占',
    allowed: '可接入',
    unallowed: '不可接入',
    addProfileSuccess: '添加PDN模板成功',
    modProfileSuccess: '修改PDN模板成功',
    delProfileSuccess: '删除PDN模板成功',
    qryProfileSuccess: '查询PDN模板成功',
    pleaseSelectDatas: '请选择数据!',
    pleaseSelectOneData: '请选择一条数据!',
    profileId: 'PDN模板ID',
    profileName: '模板名称',
    apnName: '接入点名称',
    pdnType: 'PDN类型',
    chargingCharacteristics: '签约APN计费特性',
    apnAMBR_UL: 'APN上行AMBR(kbps)',
    apnAMBR_DL: 'APN下行AMBR(kbps)',
    vplmnAllowed: '漫游地接入',
    qci: 'QCI',
    arp0: 'ARP可抢占',
    arp2_5: 'ARP优先级',
    arp6: 'ARP可被抢占',
    pgwIpv4Addr: 'PGW IPV4地址',
    pgwIpv6Addr: 'PGW IPV6地址',
    pgwHostName: 'PGW 主机名',
    pgwRealmName: 'PGW 域名',
    inquiry: '询问',
    delConfirm: '确定要删除吗？',
    selected: '已选择',
    item: '项',
    logger: '日志',
    required: '此处不可为空',
    partofpdn: '该值必须是关联PDN模板ID中的一项',
  },
  Profile: {
    nelist: '网元列表',
    pleaseSelectNE: '请选择网元',
    crumb: '开户管理/LTE管理/用户签约模板',
    add: '增加',
    modify: '修改',
    remove: '删除',
    refresh: '刷新',
    addProfile: '新增用户签约模板',
    modProfile: '修改用户签约模板',
    confirm: '确定',
    cancel: '取消',
    success: '成功',
    failed: '失败',
    addProfileSuccess: '添加用户签约模板成功',
    modProfileSuccess: '修改用户签约模板成功',
    delProfileSuccess: '删除用户签约模板成功',
    qryProfileSuccess: '查询用户签约模板成功',
    pleaseSelectDatas: '请选择数据!',
    pleaseSelectOneData: '请选择一条数据!',
    profileId: '用户签约模板ID',
    RelatedProfile: '关联用户签约模板',
    profileName: '模板名称',
    ntwAccessMode: '入网模式',
    profileMaxUl: '最大上行带宽（UE-AMBR/Kbps）',
    profileMaxDl: '最大下行带宽（UE-AMBR/Kbps）',
    pdnProfileLst: '关联PDN模板ID',
    dftPDNProfileID: '默认PDN模板ID',
    mccmncObj: '国家码&网络码',
    chargingChars: 'UE计费特性',
    subsPeriodicRauTauTimer: 'RAU/TAU定时器（s）',
    zonalCodeObj: '用户漫游区码',
    inquiry: '询问',
    delConfirm: '确定要删除吗？',
    selected: '已选择',
    item: '项',
    items: '项',
    mccMncCode: '国家码&网络码',
    zonalCode: '用户漫游区码',
    pdnProfileList: 'PDN模板',
    pdnProfileId: '关联PDN模板ID',
    pdnProfileName: 'PDN模板名称',
    pdnApnName: '接入点名称',
    logger: '日志',
    maxadd:'至多添加',
    minadd:'最少添加',
    maxadd11:'至多11项',
    charAt32: '请输入32位以内字符',
    repeatMCCMNC: '存在重复的国家码&区域码',
    repeatCode: '存在重复的用户漫游区码',
  },
  LteUser: {
    nelist: '网元列表',
    pleaseSelectNE: '请选择网元',
    crumb: '开户管理/LTE管理/用户管理',
    imsiSearch: '输入IMSI号进行查询',
    add: '开户',
    addBatch: '批量开户',
    modify: '修改',
    remove: '删除',
    removeRange: '范围删除',
    refresh: '刷新',
    search: '搜索',
    addUser: '新增用户',
    addBatchUser: '批量开户',
    modUser: '修改用户',
    delRange: '范围删除',
    confirm: '确定',
    cancel: '取消',
    success: '成功',
    failed: '失败',
    addUserSuccess: '添加用户成功',
    modUserSuccess: '修改用户成功',
    delUserSuccess: '删除用户成功',
    qryUserSuccess: '查询用户成功',
    pleaseSelectDatas: '请选择数据!',
    pleaseSelectOneData: '请选择一条数据!',
    imsi: 'IMSI',
    msisdn: '移动用户号',
    profile_id: '用户签约模板ID',
    imsi_status: '用户签约状态',
    imsi_odb: 'ODB',
    staticAddrCount: '静态地址个数',
    inquiry: '询问',
    delConfirm: '确定要删除吗？',
    selected: '已选择',
    item: '项',
    pdnProfileList: '关联PDN模板',
    pdnProfileId: 'PDN模板ID',
    pdnType: 'PDN类型',
    pdnApnName: '接入点名称',
    staticAddr: '签约静态地址',
    GRANTED: 'GRANTED',
    ODB: 'ODB',
    DISABLED: 'DISABLED',
    ipv4_addr: 'IMSI静态IPV4地址',
    ipv6_addr: 'IMSI静态IPV6地址',
    odb_0: '禁止用户所有数据业务',
    odb_1: '禁止所有Home Routed漫游模式的数据业务',
    odb_2: '禁止所有Local Breakout漫游模式的数据业务',
    odb_3: '禁止漫游接入',
    imsiRange: 'IMSI范围',
    character15: '15字符',
    logger: '日志',
    staticAddrNum: '静态地址个数',
    configStaticIP: '配置静态IP地址',
    wrong: '错误',
    atleastone: '至少包含1条',
    atmost: '最多包含10000条',
    length15: '固定长度15',
    invalidnum: '无效的整数',
    imsireg:'输入非0开头的整数',
    batchAddUserTip: '批量开户',
    batchDelUserTip: '批量删除',
    exceedImsi:'批量开户数据中存在IMSI大于15位的数据',
    exceedMsisdn:'批量开户数据中存在MSISDN大于11位的数据',
    ipv4InfoCantEmpty: 'ipv4地址不可为空',
  },
  Pm: {
    taskList: '任务列表',
    pmManagement: '性能管理',
    cycleMeasurement: '周期测量',
    realTimeMeasurement: '实时测量',
    noRealTaskManagement: '非实时任务管理',
    noRealDataQuery: '非实时数据查询',
    performanceIndicatorManage: '性能指标管理',
    kpiChartShow: 'KPI图表展示',
    homePage: '首页',
    measurementObject: '测量对象',
    ne: '网元',
    measureTaskManagement: '测量任务管理',
    taskID: '任务编码',
    taskName: '任务名称',
    measureCycle: '测量周期',
    taskDescription: '任务描述',
    uniformityState: '一致性检查',
    taskState: '任务状态',
    timeMode: '时间模式',
    start_time: '开始时间',
    end_time: '结束时间',
    syncTime: '同步时间',
    hangUpStartTime: '挂起开始时间',
    hangUpEndTime: '挂起结束时间',
    editor: '编辑人',
    editTime: '编辑时间',
    establishTask: '创建任务',
    hangUpTask: '挂起任务',
    delTask: '删除任务',
    modifyTask: '修改任务',
    activeTask: '激活任务',
    checkUniformity: '一致性检查',
    synchronousDownload: '同步下载',
    dataMining: '数据补采',
    integrityCheck: '完整性检查',
    queryDetailInfo: '详细信息查询',
    inputSearhString: '请输入查询条件',
    searchNe: '搜索网元',
    measureTask: '任务测量',
    ip: 'IP',
    consistentState: '一致性状态',
    samplingPeriod: '采样周期',
    samplingPeriod_unit: '采样周期(s)',
    taskDuration: '任务时长',
    taskEstablishTime: '任务创建时间',
    samplingStartTime: '采集开始时间',
    pauseTime: '暂停时间',
    uniformityCheckTime: '一致性检查时间',
    createTaskUser: '创建任务用户',
    taskTimeRemaining: '任务剩余时间',
    startUp: '启动',
    hangup: '挂起',
    pause: '暂停',
    export: '导出',
    queryInfo: '数据查询',
    indicator: '指标',
    measuringPosition: '测量位置',
    saveDataOrNot: '是否保存数据',

    searchByNe: '根据网元名称搜索',
    searchByName: '根据名称搜索',
    calculator: '计数器',
    system: '系统',
    custom: '自定义',
    name: '名称',
    unit: '单位',
    mode: '模式',
    invalidTime: '失效时间',
    real: '实时',
    nonReal: '非实时',
    realOrNo: '实时/非实时',
    indicatorID: '指标ID',
    indicatorState: '指标状态',
    indicatorFormulaColumn: '指标公式',
    indicatorFormulaText: '指标公式(运算显示区)',
    description: '描述',
    dataType: '数据类型',
    neType: '网元类型',
    measurementObjectClassify: '测量对象分类',
    doubleClickChoose: '双击选择指标',
    switch: '转换',
    search: '搜索',
    revoke: '撤销',
    clear: '清除',
    determine: '确定',
    confirm: '确认',
    cancel: '取消',
    finish: '完成',
    active: '激活',
    inactive: '去激活',
    times: '次',
    number: '个',
    dbm: '毫瓦分贝',
    kilobit: '1000bit',
    ms: '毫秒',
    kbps: '千比特/秒',
    seconds: '秒',
    del: '删除',
    add: '添加',
    modify: '修改',
    alertRequired: '该项不能为空',
    alertFormula1: '指标公式不能为空',
    alertFormula2: '公式中没有指标',
    alertFormula3: '公式中的指标与测量对象不匹配',
    alertFormula4: '公式长度超过256个字符',
    alertInvalidTime: '激活状态下，失效时间不能早于当前时间',
    alertData1: '请选择一条数据',
    alertInvalidDate: '请输入有效的日期',
    notInputSpace: '不允许输入空格',
    alertIsNumberHeader: '不能以数字、空格开头',
    alertMaxLength: '文字长度不能超过',
    toastHeader: '提示',
    query: '询问',
    alertHeader: '警告',
    successInfo: '操作成功',
    createTask: '创建/修改任务',
    first: '第一步',
    second: '第二步',
    preStep: '上一步',
    nextStep: '下一步',
    indicatorList: '指标列表',
    pleaseInput: '请输入',
    queryWillDel: '确认删除',
    cellMeasure: '小区测量',
    quickExport: '快捷导出',
    batchExport: '批量导出',
    oneMinute: '1分钟',
    fiveMinutes: '5分钟',
    tenMinutes: '10分钟',
    fifteenMinutes: '15分钟',
    twentyMinutes: '20分钟',
    thirtyMinutes: '30分钟',
    oneHour: '1小时',
    oneDay: '1天',
    selectNe: '选择网元',
    selectIndicator: '选择指标',
    today: '今天',
    yesterday: '昨天',
    currentWeek: '本周',
    lastWeek: '上周',
    specified: '指定',
    latest: '最新',
    queryScope: '查询范围',
    dataLatest: '数据最新',
    neLatest: '网元最新',
    sortMethod: '排序方式',
    ascending: '升序',
    descending: '降序',
    begTimeNull: '开始时间不能为空',
    endTimeNull: '结束时间不能为空',
    begTimeFormatError: '开始时间格式不对',
    endTimeFormatError: '结束时间格式不对',
    ne_name: '资源名称',
    measureObjName: '测量对象名称',
    periodTime: '时段',
    longTime: '长期',
    taskNameNull: '任务名称不能为空',
    taskDespOver256: '任务描述不能大于256字符',
    taskNameOver60: '任务名称不能大于60字符',
    onlyNumAndLetter: '只能填写数字和英文字母',
    addToFollow: '加入下侧',
    timeRange: '时间范围',
    selectNePlease: '请选择合适的网元',
    kpiChartEdit: 'KPI图表配置',
    exportChart: '导出图片',
    ne_id: '资源ID',
    chooseObject: '选择测量对象',
    chooseCycle: '选择测量周期',
    selectedKpiPath: '已选择的KPI指标路径',
    alarmKpi9: '九宫格最多只能显示9个KPI指标',
    atMostOneRealTask: '最多只能建立一个实时任务并且同时只能打开一个任务标签页',
    notCloseHome: '禁止关闭首页',
    exitTaskInfo: '已有任务信息',
    atLeastOne: '请选择至少一条记录',
    failedToStart: '启动任务失败',
    failedToCreate: '创建任务失败',
    waitCommandFinish: '请等待命令执行完毕',
    deleteSuccessfully: '删除成功',
    deleteFailed: '删除失败',
    taskInProgress: '任务正在执行...',
    consistent: '一致',
    inconsistent: '不一致',
    yes: '是',
    no: '否',
    fillCorrectTaskDuration: '请填写正确任务时长！',
    selectMOplease: '请选择测量对象！',
    selectIndicatorPlease: '请选择指标！',
    selectMSeatPlease: '请选择测量位置！',
    fillInSamplingPeriod: '请填写采样周期！',
    reportTime: '上报时间',
    processCode: '进程号',
    assocId: '偶联ID',
    dataCollection: '数据采集',
    all: '全部',
    realTimeByIndicator: '实时测量任务（按指标）',
    realTimeBySeat: '实时任务测量（按位置）',
    byIndicator: '按指标',
    bySeat: '按位置',
    performTask: '执行任务',
    selectDataPlease: '请选择数据',
    startNoLagerThanEnd: '起始时间不能晚于结束时间',
    endNoEarilerThanCurrent: '结束时间不能早于当前时间',
    pleaseSelectNe: '请选择网元节点',
    neOffline: '网元不在线',
    taskAlreadyExists: '任务已存在',
    failure: '失效',
    statistic_cycle: '统计周期（s）',
    Intodb_time: '数据入库时间',
    data_bilievable: '数据完整性',
    ne_type_id: '资源类型',
    cabinet: '柜号',
    frame: '框号',
    slot: '槽号',
    cell_id: '小区编码',
    enodeb_id: '基站编码',
    realtime_task_createTask: '创建实时测量任务',
    taskDuration_unit: '任务时长(s)',
    taskTimeRemaining_unit: '任务剩余时间(s)',
    info: '信息',
    hasSameTaskName: '已有相同名称任务！',
    hasSameIndicatorName: '已有相同名称指标！',
    indicatorName: '指标名称',
    indicatorDesc: '指标描述',
    task_started: '当前客户端已订制该任务',
    task_opened: '新建任务之前请关闭已经打开的标签窗口',
    resource: '资源',
    resource_name: '资源名称',
    resourceType: '资源类型',
    selectResource: '选择资源',
    selectResourcePlease: '请选择合适的资源',
    resourceOffline: '资源不在线',
    pleaseSelectResource: '请选择资源节点'
  },
  Spectrum: {
    NElist: '网元列表',
    spectrum_manager: '扫频管理',
    ui_pt_taskstatus: '任务状态',
    ui_pt_taskstatus_waiting: '等待中',
    ui_pt_taskstatus_submit: '提交中',
    ui_pt_taskstatus_failed: '创建失败',
    ui_pt_taskstatus_execute: '执行中',
    ui_pt_taskstatus_stop: '停止中',
    ui_pt_taskstatus_end: '已结束',
    ui_pt_starttime: '启动时间',
    ui_pt_endtime: '结束时间',
    ui_pt_enodebid: '基站编号',
    ui_pt_cell: '小区标识',
    ui_cell: '小区',
    ui_pt_spectrumcycle: '扫频周期',
    ui_pt_spectrumstop: '停止',
    ui_pt_spectrumdelete: '删除',
    ui_pt_spectrumsectorid: '扇区索引',
    ui_spectrumsectorid: '扇区索引',
    ui_pt_spectrumphycellid: '物理小区标识',
    ui_spectrumphycellid: '物理小区',
    ui_pt_spectrumseconds: '秒',
    ui_pt_spectrumstopped: '已停止',
    ui_pt_spectrumcantdelete: '不可删除',
    ui_pt_spectrum1s: '1 秒',
    ui_pt_spectrum2s: '2 秒',
    ui_pt_spectrum5s: '5 秒',
    ui_pt_spectrum10s: '10 秒',
    ui_pt_spectrumchoose: '请选择基站和小区！',
    ui_pt_spectrumbuild: '创建扫频任务',
    ui_pt_spectrumdelconform: '确定删除该扫频记录吗？',
    ui_pt_spectrumsuspendre: '暂停刷新',
    ui_pt_spectrumpeakmon: '峰值监控',
    ui_pt_spectrumavemon: '均值监控',
    ui_pt_spectrumexpimg: '导出图片',
    ui_pt_neidorname: '网元名ID / 网元名称',
    ui_pt_spectrumlist: '扫频任务列表',
    ui_pt_spectrumadd: '创建',
    ui_pt_spectrumantdgm: '天线干扰扫描示意图',
    ui_pt_spectrumfredgm: '时频干扰扫描示意图',
    ui_pt_spectrumtimlin: '时间轴',
    ui_pt_spectrumUnit: '单位：(分钟)',
    ui_pt_spectrumchfindex: '子帧索引',
    ui_pt_spectrummax: '最大值',
    ui_pt_spectrummin: '最小值',
    ui_pt_spectrumave: '平均值',
    ui_pt_spectrumsca: '频谱扫描',
    ui_pt_rbOption: 'RB Rssi(单位：dBm)',
    400: 'You cannot delete the picture being used.',
    401: 'You cannot delete system default pictures.',
    402: 'The picture has already been deleted.',
    258: 'NEs already exist in this segment.',
    ui_pt_spectrumDuration: '持续时间',
    ui_pt_spectrumunit: '单位',
    ui_pt_spectrumNoStop: '未结束',
    ui_pt_createtaskfailed: '创建任务失败',
    ui_pt_stoptaskfailed: '停止任务失败',
    ui_pt_taskresperror: '扫频结果上报异常，已停止，如需继续，请重试！',
    ui_pt_command: '命令',
    ui_pt_result: '结果',
    ui_pt_taskrespnull: '扫频结果上报异常，请停止任务，如需继续，请重试！',

    6900: '当前小区存在正在执行的扫频任务，请稍后重试！',
    6901: '关闭失败，任务已关闭或提交中，请稍后重试！',
    6902: '当前状态的任务无法被删除！',
    6903: '无法停止已经结束的任务!',
    6906: '查询扫频数据任务达到上限!',
    6907: '扫频任务异常，请停止任务，如需继续，请重试！',
    6908: '调用停止任务失败！',
    6909: '调用删除任务失败！',
    6910: '调用查询扫频数据任务失败',
    6911: '调用根据时间查询扫频数据任务失败!',
    6912: '调用查看扫频记录任务失败!',
    ui_pt_spectrum1min: '1 分钟',
    ui_pt_spectrum5min: '5 分钟',
    ui_pt_spectrum10min: '10 分钟',
    ui_pt_spectrum30min: '30 分钟',
    ui_pt_spectrum1hour: '1 小时',
    ui_pt_spectrum4hour: '4 小时',
    ui_pt_spectrum1day: '1 天',
    ui_pt_spectrum1week: '1 周',

    ui_pt_searchNe: '搜索网元：网元id/网元名称',
    ui_pt_SpectrumTaskList: '扫频任务列表',
    ui_pt_spectrumtaskcreate: '创建',
    ui_pt_removespectrumtask: '请选择任务！',
    ui_oper: '操作',
    ui_ok: '确定',
    ui_cancell: '取消',
    ui_cycle: '周期:',
    ui_Duration: '期间:'
  },
  UE: {
    ue_traffic: '上下行流量',
    ue_camera: '摄像头',
    ue_camera_name: '摄像头名称',
    ue_alias: 'UE别名',
    ue_bs_id: '基站ID',
    ue_bs_name: '基站别名',
    ue_ip: 'IP地址',
    ue_mac: 'mac地址',
    ue_ul_Traffic: '上行流量',
    ue_dl_Traffic: '下行流量',
    ue_ul_packet_rate: '上行包率',
    ue_dl_packet_rate: '下行包率',
    neList: '网元列表',
    ueTraffic: 'UE流量',
    ueCancell: '取消',
    ueConfirm: '确认',
    ueDetailData: '详细数据',
    ueSelectDatas: '请选择数据!',
    ueSelectOneData: '请选择一条数据!',
    ueSearch: '查询',
    ueManager: 'UE管理',
    ueShowMap: 'UE地图',
    ue_rsrp1: '服务小区RSRP1',
    ue_rsnp2: '服务小区RSRP2',
    ue_nrsrp1: '邻区RSRP1',
    ue_nrsnp2: '邻区RSRP2',
    ue_sinr1: 'SINR1',
    ue_sinr2: 'SINR2',
    ue_ul_data: '上行吞吐量',
    ue_dl_data: '下行吞吐量',
    ue_selected: '已选设备',
    ue_search_imsi: '搜索 IMSI',
    ue_imsi: 'IMSI',
    ue_base_enodeb: '所属基站别名',
    ue_state: 'UE 状态',
    ue_state_off: '离线',
    ue_state_up: '在线',
    ue_state_idle: '空闲',
    select_ue_data:'请选择UE',
    select_ue:'选择终端',
    bs_online_count: '基站在线总数: ',
    ue_online_count: '终端在线总数: ',
    ue_select_limit: '最多只能选5个',
    legend_bs:'基站',
    legend_ue:'终端',
    legend:'图例',
    latLng: '坐标',
    ue_chart: '订阅UE图表',
    pleaseSelectNe: '请选择网元节点'
  },
  SubscriberIms: {
    groupTemplate: '开组模板',
    userTemplate: '开户模板',
    insertName: '请输入名称',
    insertStaffName: '请输入职员名称',
    neList: '网元列表',
    clusterUserCreate: '用户开户',
    clusterGroupCreate: '用户开组',
    userManagement: 'IMS用户管理',
    organization: '组织架构',

    menuTitle: '开户管理/IMS管理/群组管理',
    menuTitleGroupMcs: '开户管理/MCS管理/群组管理',
    menuTitleUser: '开户管理/IMS管理/用户管理',
    menuTitleUserMcs: '开户管理/MCS管理/用户管理',
    addSiblingNode: '添加同级节点',
    addChildNode: '添加子节点',
    modifyNode: '修改节点',
    add: '添加',
    del: '删除',
    mod: '修改',
    import: '导入',
    export: '导出(按搜索条件)',
    addUser: '开户',
    batchAddUser: '批量开户',
    modUser: '修改用户',
    batchModUser: '批量修改',
    deleteUser: '删除用户',
    addUserMember: '添加隶属用户',
    qryUserMember: '查询隶属用户',
    addGroupMember: '添加隶属组',
    qryGroupMember: '查询隶属组',
    delUserMember: '删除隶属用户',
    modUserMember: '修改隶属用户',
    addGroup: '开组',
    modGroup: '修改组',
    batchAddGroup: '批量开组',
    batchModGroup: '批量修改',
    fresh: '刷新',
    find: '查询',
    warn: '警告',
    reminder: '提示',
    logTitle: '日志',
    confirm: '确定',
    cancel: '取消',
    close: '关闭',
    deleteConfirm: '确认删除选中的数据吗?',
    chooseNodeTip: '请选择节点',
    notChooseRootTip: '无法添加主节点的平级节点',
    notModRootTip: '无法修改顶级节点',
    notDelRootNode: '顶级节点不能删除',
    preDelChildNode: '请先删除子节点',
    nodesCountTip: '最多添加6级节点',
    requestResTip: '请求失败，请检查地址和参数',
    info: '信息',
    search: '搜索',
    template: '宽带模板',
    subInfoDiv: '用户设备',
    impuinfoDiv: '用户基础信息',
    templateinfDiv: '模板基础信息',
    serviceProfileInfoDiv: '用户服务信息',
    supplementaryInfoDiv: '用户补充信息',
    groupProfileInfoDiv: '组服务信息',
    tgrpserviceDiv: '组服务信息',
    tgrpadditionalDiv: '组补充信息',
    lte_ems_subscriber_groupMatchError: '群组号码个数与组标识号码个数不一致',
    lte_hss_group_groupIdentityCompare: '起始组标识号不能大于终止标识号',
    checkZoneTip: '请校验区号',
    noZoneDial1Tip: '数据范围是900到999',
    noZoneDial4Tip: '数据范围是00000到99999',
    noZoneDial6Tip: '数据范围是000到999',
    numDialTip1: '数据范围是100到109',
    numDialTip2: '数据范围是00000到99999',
    numDialTip3: '数据范围是00001到32767',
    numDialTip4: '数据范围是00001到29999,30019到32767',
    numDialTip5: '数据范围是100到109',
    numDialTip6: '数据范围是200到899',
    numDialTip7: '数据范围是00001到99999',
    numDialTip8: '数据范围是200到899',
    numDialTip9: '数据范围是200到549',
    zoneTip: '区号范围须在328~806',
    numTip: '个号范围是00001~29999或30019~32767',
    DMRZoneTip: 'DMR拨号方案区号须为2位',
    solid_3: '固定3位数字',
    solid_5: '固定5位数字',
    toomuchUsers: '批量开户数量不能超过1000',
    batchAddUserTip: '批量开户',
    batchModUserTip: '批量修改',
    waitTip: '请稍候......',
    qryVpnFailTip: '查询组织架构失败',
    selectVButton: '选择',
    qryDialPlanFailTip: '拨号方案查询失败',
    notSuppoDialTip: '网管不支持此拨号方案',
    chooseUserDataTip: '请选择用户数据',
    chooseGroupDataTip: '请选择组数据',
    notAddDynamicsTip: '禁止加入动态组',
    notAddNetgate: '网关类用户禁止加入组',
    passwordEqual: '密码与确认密码要保持一致',
    userNo: '用户号码',
    userName: '用户名称',
    groupNo: '组号码',
    groupName: '组名称',
    groupType: '组类型',
    grpproperty: '组属性',
    grpAttribute: '组特性',
    grpIdentity: '组标识号',
    impFileTypeErrTip: '导入的数据格式不对',
    controlMember: '组成员管理',
    qryAdvance: '高级查询',
    grptype0: '普通组',
    grptype1: '漫游组',
    grptype2: '混合组',
    grptype3: '跨系统组',
    grptype4: '分级组',
    grpproperty0: '静态组',
    grpproperty1: '动态组',
    impugrpclass: '用户组内权限',
    impugrppriority: '用户组内优先级',
    operSucess: '操作成功',
    operObj: '操作对象',
    operResult: '操作结果',
    loading: '加载中...',
    rtttype: '用户类型',
    rtttype1: '无线终端',
    rtttype2: '系统调度台',
    rtttype3: 'PoC终端',
    rtttype4: '双模终端',
    rtttype5: '录音/录像服务器',
    rtttype6: '宽带终端',
    rtttype6_2: 'PNAS终端',
    rtttype8: '统一定位系统',
    substatus0: '正常',
    substatus1: '摇晕',
    substatus2: '摇毙',
    regstatus0: '非注册',
    regstatus1: '注册',
    userenable: '用户使能',
    userenable0: '禁止使用',
    userenable1: '可以使用',
    noCheckDataTip: '请选择一条数据',
    checkDataMoreTip: '只能选择一条数据',
    checkDateLessTip: '请选择多条数据',
    notModWithDifTypeTip: '不同类型不允许修改',
    checkVpnTip: '请选择组织架构',
    vpnid: '组织架构节点',
    loadingvpn: 'VPN载入',
    regstatus: '注册状态',
    substatus: '设备状态',
    createtime: '创建时间',
    activetime: '激活时间',
    resultReturnFailedTip: '返回结果有误，请联系管理员',
    staffTitle: '人员信息',
    staffId: '职员编号',
    staffName: '职员名称',
    licenseNum: '车牌号',
    subNum: '用户号码',
    post: '工种',
    profession: '职务名称',
    unitName: '单位名称',
    unitCode: '单位代码',
    mobile: '手机号',
    use: '用途类型',
    terType: '终端类型',
    temTitle: '开户管理/IMS管理/模板管理',
    infoTitle: '开户管理/IMS管理/人员信息管理',
    tempnum: '模板号',
    tempname: '模板名',
    temptype: '模板类型',
    tempdate: '创建时间',
    all: '全部',
    user: '用户',
    group: '组',
    noDialTip: '没有查询到拨号方案',
    endNOLessStartNo: '截止个号应大于起始个号',
    sortBtn: '排序',
    unregister: '未注册',
    register: '已注册',
    nelist: '网元列表',
    userInfo: '用户信息',
    lsgxInfo: '隶属关系配置信息',
    dyGroupNotConfigLSGX: '动态组不支持添加隶属关系',
    noDataCanOper: '没有可以操作的数据',
    qryDataError: '设备侧返回数据错误',
    fuzzyQryNotApplSort: '模糊查询不支持排序',
    noSortVpn: '没有需要排序的节点',
    noOperatRole: '该节点没有操作权限',
    userNumTitle: '*用户号码:\r\n符合拨号方案',
    grpNumTitle: '*组号码:\r\n符合拨号方案',
    dialogListSpan: '操作完成，成功 ',
    hour: '时',
    minute: '分',
    notFitDialPlan: '组号码不符合拨号方案规则',
    invalidInt: '无效的整数',
    grpnumrange: '输入值必须在1到99999999之间',
    invalideChar: '无效的特殊字符',
    maxlen15: '不能超过15个字符',
    exportdata: '导出',
    importdata: '导入',
    pleaseChoose: '请选择',
    regClassNeeded: '登记权限至少需要选择一项',
    require: '该项不能为空',
    charAt63: '只能输入8~63位字符',
    passwordRegex: '至少包含数字、大小写字母、特殊字符中的两种',
    charAt1To50: '只能输入{0}~{1}位字节',
    groupNumLimitTip: '单次最大支持开1000个组',
  },
  ej2Components: {
    'grid': {
      'EmptyRecord': '无记录'
    },
    'pager': {
      'currentPageInfo': '第 {0} 页 共 {1} 页',
      'totalItemsInfo': '({0} 条)',
      'firstPageTooltip': '首页',
      'lastPageTooltip': '最后一页',
      'nextPageTooltip': '下一页',
      'previousPageTooltip': '上一页',
      'nextPagerTooltip': '到下一页',
      'previousPagerTooltip': '到前一页',
      'pagerDropDown': '每页条数',
      'pagerAllDropDown': '条数',
      'All': '全部'
    },
    'uploader': {
      'Browse': '浏览',
      'Clear': '清除',
      'Upload': '上传',
      'dropFilesHint': '删除文件',
      'uploadFailedMessage': '上传失败',
      'uploadSuccessMessage': '上传成功',
      'readyToUploadMessage':'准备上传',
      "removedSuccessMessage": "已成功删除文件",
      "removedFailedMessage": "该文件无法删除",
      "inProgress": "下载",
      "invalidFileType": "文件类型不允许",
      "remove": "删除文件",
      "cancel": "取消",
      "delete": "删除文件"
    },
    'dialog': {
      'close': '关闭'
    },
    'chart': {
      'ZoomIn': '放大',
      'ZoomOut': '缩小',
      'Zoom': '缩放',
      'Pan': '平移',
      'Reset': '重置',
    },
    'datepicker': {
      'placeholder': '请选择一个日期',
      'today': '今天'
    },
    'datetimepicker': {
      'placeholder': '请选择日期和时间',
      'today': '今天'
    },
    'daterangepicker': {
      'placeholder': '选择一个区域',
      'startLabel': '选择开始日期',
      'endLabel': '选择结束日期',
      'applyText': '确定',
      'cancelText': '取消',
      'selectedDays': '选定日期',
      'days': '天数',
      'customRange': '定制区域'
    },
    'timepicker': {
      'placeholder': '选择时间'
    },
    'dropdowns': {
      'noRecordsTemplate': '没有找到记录',
      'actionFailureTemplate': '请求失败'
    },
    'numerictextbox': {
      'incrementTitle': '增加',
      'decrementTitle': '减少'
    }
  },
  DataManagent: {
    neid: '网元编号',
    clientIp: '客户端地址',
    distIp: '目标地址',
    systemUser: '网管用户',
    opTime: '操作时间',
    neVersion: '网元版本',
    opType: '操作类型',
    opResult: '操作结果',
    createDataFileFail: '生成数据文件失败',
    requestTimeOut: '请求超时',
    export: '导出',
    import: '导入',
    chooseDataTip: '请选择数据',
    chooseNeidTip: '请先选择网元',
    success: '操作成功',
    fail: '操作失败',
    crumb: '开户管理/数据管理',
  },
  DNN: {
    crumb: '开户管理/udm管理/DNN模板',
    profileId: 'DNN模板ID',
    profileName: '模板名称',
    dnnName: '接入点名称',
    ambrUp: 'DNN上行AMBR(kbps)',
    ambrDown: 'DNN下行AMBR(kbps)',
    chargeChars: '计费特性',
    pduSessionType: 'PDU会话类型',
    dftPduSessionType: '默认PDU会话类型',
    sscMode: 'SSC模式',
    dftSscMode: '默认SSC模式',
    fiveQi: '5QI',
    fiveQiPriorityLevel: '5QI优先级',
    pl: 'ARP优先级',
    pev: 'ARP可被强占',
    pec: 'ARP可抢占',
    pduType0: 'IPv4',
    pduType1: 'IPv6',
    pduType2: 'IPV4V6',
    pduType3: 'TRUCTURED',
    pduType4: 'ETHERNET',
    sscMode0: 'SSC_MODE_1',
    sscMode1: 'SSC_MODE_2',
    sscMode2: 'SSC_MODE_3',
    addProfileSuccess: '添加DNN模板成功',
    modProfileSuccess: '修改DNN模板成功',
    delProfileSuccess: '删除DNN模板成功',
    qryProfileSuccess: '查询DNN模板成功',
    dnnParamInfo: 'DNN参数',
    pduSessionParamInfo: 'PDU会话参数',
    sscModeParamInfo: 'SSC模式参数',
    qosParamInfo: 'Qos参数',
    enabled: '可被抢占',
    disabled: '不可被抢占',
    enabledPec: '可抢占',
    disabledPec: '不可抢占',
    max16: '不可超过16条',
    max4: '不可超过4条',
  },
  Snssai: {
    crumb: '开户管理/udm管理/网络切片模板',
    addProfile: '新增网络切片模板',
    modProfile: '修改网络切片模板',
    addProfileSuccess: '添加网络切片模板成功',
    modProfileSuccess: '修改网络切片模板成功',
    delProfileSuccess: '删除网络切片模板成功',
    qryProfileSuccess: '查询网络切片模板成功',
    dnnProfileList: 'DNN模板',
    sst: 'SST',
    sd: 'SD',
    profileId: '网络切片模板ID',
    profileName: '模板名称',
    dnnProfile: '关联DNN模板ID',
    dnnProfileName: 'DNN名称',
  },
  AmData: {
    crumb: '开户管理/udm管理/AM-DATA模板',
    addProfile: '新增AM-DATA模板',
    modProfile: '修改AM-DATA模板',
    addProfileSuccess: '添加AM-DATA模板成功',
    modProfileSuccess: '修改AM-DATA模板成功',
    delProfileSuccess: '删除AM-DATA模板成功',
    qryProfileSuccess: '查询AM-DATA模板成功',
    ueAmbrUp: '最大上行带宽(UE-AMBR/Kbps)',
    ueAmbrDown: '最大下行带宽(UE-AMBR/Kbps)',
    profileId: 'AM-DATA模板ID',
    profileName: '模板名称',
  },
  Plmn: {
    crumb: '开户管理/udm管理/PLMN模板',
    addProfile: '新增PLMN模板',
    modProfile: '修改PLMN模板',
    addProfileSuccess: '添加PLMN模板成功',
    modProfileSuccess: '修改PLMN模板成功',
    delProfileSuccess: '删除PLMN模板成功',
    qryProfileSuccess: '查询PLMN模板成功',
    mcc: '国家码',
    mnc: '网络码',
    amDataProfileIds: '关联AM-DATA模板',
    snssaiProfileIds: '关联网络切片模板',
    amDataProfile: 'AM-DATA模板',
    snssaiProfile: '网络切片模板',
    profileId: 'PLMN模板ID',
    profileName: '模板名称',
    amDataProfileId: '关联AM-DATA模板ID',
    amDataProfileName: 'AM-DATA模板名称',
    snssaiProfileId: '关联网络切片模板ID',
    snssaiProfileName: '网络切片模板名称',
  },
  Usersub: {
    crumb: '开户管理/udm管理/用户签约模板',
    profileId: '用户签约模板ID',
    profileName: '模板名称',
    plmnInfos: 'PLMN',
    addProfile: '新增用户签约模板',
    modProfile: '修改用户签约模板',
    addProfileSuccess: '添加用户签约模板成功',
    modProfileSuccess: '修改用户签约模板成功',
    delProfileSuccess: '删除用户签约模板成功',
    qryProfileSuccess: '查询用户签约模板成功',
    plmnProfileId: '关联PLMN模板ID',
    plmnProfileName: 'PLMN模板名称',
    plmnProfileIds: '关联PLMN模板',
  },
  Supi: {
    crumb: '开户管理/udm管理/用户管理',
    supiSearch: '输入SUPI号进行查询',
    supi: 'SUPI',
    gpsi: 'GPSI',
    userSubProfileId: '关联用户签约模板',
    ipv4Addr: '静态IPV4地址',
    ipv6Addr: '静态IPV6地址',
    supiRange: 'SUPI范围',
  },
  DeployManagement: {
    detail: '详情'
  }
};
